"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Geometry = _interopRequireDefault(require("../geom/Geometry"));

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _Point = _interopRequireDefault(require("../geom/Point"));

var _Double = _interopRequireDefault(require("../../../../java/lang/Double"));

var _GeometryCollection = _interopRequireDefault(require("../geom/GeometryCollection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var InteriorPointPoint =
/*#__PURE__*/
function () {
  function InteriorPointPoint() {
    _classCallCheck(this, InteriorPointPoint);

    InteriorPointPoint.constructor_.apply(this, arguments);
  }

  _createClass(InteriorPointPoint, [{
    key: "getInteriorPoint",
    value: function getInteriorPoint() {
      return this._interiorPoint;
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments[0] instanceof _Geometry.default) {
        var geom = arguments[0];

        if (geom instanceof _Point.default) {
          this.add(geom.getCoordinate());
        } else if (geom instanceof _GeometryCollection.default) {
          var gc = geom;

          for (var i = 0; i < gc.getNumGeometries(); i++) {
            this.add(gc.getGeometryN(i));
          }
        }
      } else if (arguments[0] instanceof _Coordinate.default) {
        var point = arguments[0];
        var dist = point.distance(this._centroid);

        if (dist < this._minDistance) {
          this._interiorPoint = new _Coordinate.default(point);
          this._minDistance = dist;
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return InteriorPointPoint;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return InteriorPointPoint;
}();

exports.default = InteriorPointPoint;

InteriorPointPoint.constructor_ = function () {
  this._centroid = null;
  this._minDistance = _Double.default.MAX_VALUE;
  this._interiorPoint = null;
  var g = arguments[0];
  this._centroid = g.getCentroid().getCoordinate();
  this.add(g);
};